
    <h3 mat-dialog-title [hidden]="!newNote">Write a new note</h3>
    <h3 mat-dialog-title [hidden]="newNote">Edit note</h3>
    <mat-dialog-content>
          <mat-form-field floatLabel="always" class="w-100">
              <textarea matInput name="notes" required [(ngModel)]="note" style="min-height: 150px "
                        placeholder="Note" class="textarea-note"></textarea>
          </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-center">
	    <button mat-raised-button [mat-dialog-close]="false">Close</button>
	    <button mat-raised-button color="primary" class="mr-1" [disabled]="note.length === 0"
                (click)="addUpdateNote()">Save</button>
    </mat-dialog-actions>
  